module.exports = __webpack_public_path__ + "components/tide-table/static/moon-last-quarter-d6583545c14325aca0ccb09d828025e8.svg";